var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.text)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.text[0] !== undefined ? _vm.text[0] : _vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }